import {
  initialState,
  Actions,
  State,
  GET_ALL_WELCOME_CONTENT_POSTS,
  UPDATE_CURRENT_ALL_WELCOME_CONTENT,
  GET_ALL_WELCOME_CONTENT_POSTS_SUCCESS,
  GET_ALL_WELCOME_CONTENT_POSTS_ERROR,
  RESET_GET_ALL_WELCOME_CONTENT_POSTS,
} from "../../types/welcome-content/get-all-welcome-content-posts";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_WELCOME_CONTENT_POSTS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_ALL_WELCOME_CONTENT_POSTS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_ALL_WELCOME_CONTENT_POSTS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case UPDATE_CURRENT_ALL_WELCOME_CONTENT:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: false,
        },
      };
    case RESET_GET_ALL_WELCOME_CONTENT_POSTS:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
